import React, { useEffect, useState } from "react";
import back from "../Assets/dsp/back.svg";
import "../Style/Component/Orderdetails.css";
import accept from "../Assets/Trackride/created.svg";
import collect from "../Assets/Trackride/assigned.svg";
import dispatch from "../Assets/Trackride/icon3.svg";
import dealer from "../Assets/Trackride/icon4.svg";
import complete from "../Assets/Trackride/complete.svg";
import cancel from "../Assets/Trackride/cancelorder.svg";
import call from "../Assets/Trackride/call.svg";
import { useNavigate } from "react-router-dom";
import { AlarmCheck, AlertTriangle } from "lucide-react";

const Orderdetails = ({ ridedetails }) => {
  const navigate = useNavigate();
  const [showCancel, setShowCancel] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [cancelledat, setCancelledAt] = useState(0);
  const reasons = [
    "Customer not reachable",
    "Incorrect or incomplete address",
    "Scrap quantity below minimum requirement",
    "Weather or safety concerns",
    "Pickup rescheduled by admin",
    "Other",
  ];

  useEffect(() => {
    if (!ridedetails?.raw?.statusTimeline) return;

    const cancelIndex = ridedetails.raw.statusTimeline.findIndex(
      (item) => item.status === "CANCELLED",
    );

    setCancelledAt(cancelIndex); // -1 if not found
  }, [ridedetails]);

  useEffect(() => {
    if (!showCancel) return;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [showCancel]);

  function formatDateWithRelativeTime(isoString) {
    const date = new Date(isoString);

    // Format date like "Feb 10, 6:00 PM"
    const formattedDate = date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${formattedDate}`;
  }
  const formatDateTime = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  return (
    <div className="orderdetails">
      <div className="orderdetailshead">
        <div className="lefthead">
          <img
            src={back}
            style={{ cursor: "pointer", marginRight: "10px" }}
            onClick={() => navigate(-1)}
            alt="backarrow"
          />
          <h2>Ride Details</h2>
        </div>

        <div className="righthead">
          <div className="rightone">
          </div>
          <div className="righttwo">
            <p className="md">
              Expected Completion Time
              <span className="sm">
                {formatDateWithRelativeTime(
                  ridedetails?.rideDetails?.expectedPickupTime,
                )}
              </span>
            </p>
          </div>
        </div>

        {/* <div className="cancel" onClick={() => setShowCancel(true)}>
          <img src={cancel} />
          <span>Cancel Order</span>
        </div> */}
      </div>

      <div className="orderdetailsbody">
        <table className="orderdetailsbodytable">
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Phone Number</th>
              <th>Pickup Address</th>
              <th>Drop Address</th>
              <th>Ride Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{ridedetails?.rideDetails?.customerName}</td>
              <td>{ridedetails?.rideDetails?.customerPhone}</td>
              <td>{ridedetails?.rideDetails?.pickupAddress}</td>
              <td>{ridedetails?.rideDetails?.dropAddress}</td>
              <td>{ridedetails?.rideDetails?.rideType}</td>
              <td>
                <a
                  onClick={() =>
                    (window.location.href = `tel:${ridedetails?.rideDetails?.customerPhone}`)
                  }
                  className="call-btn"
                >
                  <img src={call} style={{ cursor: "pointer" }} />
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="orderdetailstrack">
          <div className="forabsolute">
            <div className="progressbar">
              <div
                className="progressbarlive"
                style={{
                  backgroundColor:
                    cancelledat !== null && cancelledat >= 0
                      ? "rgb(241, 55, 55)"
                      : "var(--primary)",
                  width: `${ridedetails?.completionPercentage}%`,
                  msOverflowX: "hidden",
                }}
              />
            </div>

            <div className="trackstatus">
              <div className="accepted">
                <div
                  className="statusimage"
                  style={{ border: "2px solid green", background: "#B2FFA9" }}
                >
                  <img src={accept} />
                </div>
                <p className="md">
                  Ride Requested
                  {/* <span className="sm">Dec 10 Wednesday - 10:00 am</span> */}
                  <span className="sm">
                    {ridedetails?.raw?.createdAt &&
                      new Date(ridedetails.raw?.createdAt)
                        .toLocaleString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })
                        .replace(",", "")
                        .toUpperCase()}
                    {/* {ridedetails?.raw?.statusTimeline?.[0]?.timestamp} */}
                  </span>
                </p>
              </div>
              <div className="accepted">
                <div
                  className="statusimage"
                  style={
                    ridedetails?.raw?.statusTimeline?.[0]?.timestamp
                      ? { border: "2px solid green", background: "#B2FFA9" }
                      : cancelledat >= 0
                        ? { border: "2px solid red", background: "#edb1b1ff" }
                        : undefined
                  }
                >
                  <img src={dealer} />
                </div>
                <p className="md">
                  Driver Assigned
                  <span className="sm">
                    {ridedetails?.raw?.statusTimeline?.[0]?.timestamp &&
                      new Date(ridedetails.raw?.statusTimeline[0].timestamp)
                        .toLocaleString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })
                        .replace(",", "")
                        .toUpperCase()}
                    {/* {ridedetails?.raw?.statusTimeline?.[0]?.timestamp} */}
                  </span>
                </p>
              </div>
              <div className="accepted">
                <div
                  className="statusimage"
                  style={
                    ridedetails?.raw?.statusTimeline?.[2]?.timestamp
                      ? { border: "2px solid green", background: "#B2FFA9" }
                      : cancelledat >= 0
                        ? { border: "2px solid red", background: "#edb1b1ff" }
                        : undefined
                  }
                >
                  <img src={dispatch} />
                </div>
                <p className="md">
                  Driver Arrived
                  <span className="sm">
                    {ridedetails?.raw?.statusTimeline?.[2]?.timestamp &&
                      new Date(ridedetails.raw?.statusTimeline[2].timestamp)
                        .toLocaleString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })
                        .replace(",", "")
                        .toUpperCase()}
                    {/* {ridedetails?.raw?.statusTimeline?.[0]?.timestamp} */}
                  </span>
                </p>
              </div>
              <div className="accepted">
                <div
                  className="statusimage"
                  style={
                    ridedetails?.raw?.statusTimeline?.[3]?.timestamp
                      ? { border: "2px solid green", background: "#B2FFA9" }
                      : cancelledat >= 0
                        ? { border: "2px solid red", background: "#edb1b1ff" }
                        : undefined
                  }
                >
                  <img src={collect} />
                </div>
                <p className="md">
                  Ride Started
                  <span className="sm">
                    {ridedetails?.raw?.statusTimeline?.[3]?.timestamp &&
                      new Date(ridedetails.raw?.statusTimeline[3].timestamp)
                        .toLocaleString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })
                        .replace(",", "")
                        .toUpperCase()}
                    {/* {ridedetails?.raw?.statusTimeline?.[0]?.timestamp} */}
                  </span>
                </p>
              </div>
              {cancelledat === -1 || cancelledat === null ? (
                <div className="accepted">
                  <div
                    className="statusimage"
                    style={
                      ridedetails?.raw?.statusTimeline?.[5]?.timestamp
                        ? { border: "2px solid green", background: "#B2FFA9" }
                        : cancelledat >= 0
                          ? { border: "2px solid red", background: "#edb1b1ff" }
                          : undefined
                    }
                  >
                    <img src={complete} />
                  </div>
                  <p className="md">
                    Ride Completed
                    <span className="sm">
                      {ridedetails?.raw?.statusTimeline?.[5]?.timestamp &&
                        new Date(ridedetails.raw?.statusTimeline[5].timestamp)
                          .toLocaleString("en-US", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                          })
                          .replace(",", "")
                          .toUpperCase()}
                      {/* {ridedetails?.raw?.statusTimeline?.[0]?.timestamp} */}
                    </span>
                  </p>
                </div>
              ) : (
                <div className="accepted">
                  <div
                    className="statusimage"
                    style={
                      ridedetails?.raw?.statusTimeline?.[cancelledat]?.timestamp
                        ? // ? { border: "2px solid green", background: "#B2FFA9" }
                        {
                          border: "2px solid red",
                          background: "rgb(241, 55, 55)",
                        }
                        : undefined
                    }
                  >
                    <img src={cancel} />
                  </div>
                  <p className="md">
                    Ride Cancelled
                    <span className="sm">
                      {ridedetails?.raw?.statusTimeline?.[cancelledat]
                        ?.timestamp &&
                        new Date(
                          ridedetails.raw?.statusTimeline[cancelledat]
                            .timestamp,
                        )
                          .toLocaleString("en-US", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                          })
                          .replace(",", "")
                          .toUpperCase()}
                      {/* {ridedetails?.raw?.statusTimeline?.[0]?.timestamp} */}
                    </span>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="orderdetailstable">

          {(
            (ridedetails?.raw?.userReason || ridedetails?.raw?.driverReason)) && (
              <div className="cancel-card">
                <h3 className="cancel-title">
                  <AlertTriangle size={18} />
                  <span>Early Drop</span>
                </h3>
                <div className="cancel-content">
                  {/* USER REASON */}
                  {ridedetails?.raw?.userReason && (
                    <div className="cancel-box">
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <p className="cancel-label">User Reason</p>
                        {ridedetails.raw.userReasonAt && (
                          <span className="cancel-time">
                            {formatDateTime(ridedetails.raw.userReasonAt)}
                          </span>
                        )}
                      </div>
                      <p className="cancel-text">
                        {ridedetails.raw.userReason}
                      </p>

                    </div>
                  )}
                  {/* DRIVER REASON */}
                  {ridedetails?.raw?.driverReason && (
                    <div className="cancel-box">
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <p className="cancel-label">Driver Reason</p>
                        {ridedetails.raw.driverReasonAt && (
                          <span className="cancel-time">
                            {formatDateTime(ridedetails.raw.driverReasonAt)}
                          </span>
                        )}
                      </div>
                      <p className="cancel-text">
                        {ridedetails.raw.driverReason}
                      </p>

                    </div>
                  )}
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default Orderdetails;
